import { Form as FormClass } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

class SoftwarePaymentForm extends FormClass {
  constructor(values: object) {
    super(values, {
      amount: 'cents',
      currency: 'string',
      date: 'date',
    })
    makeObservable(this, {
      requiredFieldsEmpty: computed,
    })
  }

  get requiredFieldsEmpty() {
    return ['amount', 'currency', 'date'].some((field: string) => {
      return !this.get(field).value
    })
  }
}

export default SoftwarePaymentForm
